import { Link } from 'gatsby'

interface CheckEmailNoticeProps {
  email: string
}

const CheckEmailNotice = ({ email }: CheckEmailNoticeProps) => {
  return (
    <>
      <h1 className="title has-text-midnightBlue is-spaced">Check Your Email</h1>

      <p className="content mt-3">We need to verify your email address before we can send your results there.</p>

      <p className="content mt-3">
        We've sent an email to <span className="has-text-primary">{email}</span> with a link to verify your email
        address, please check your email and click the link to confirm your registration. We will <em>only</em> process
        your result once you click the link we've sent you.
      </p>

      <div className="content mt-3">
        <h4>Didn't get an email?</h4>

        <p>Follow these steps in order:</p>

        <ol>
          <li>
            <strong>Check your email is correct</strong>
            <br />
            We sent the email to <span className="has-text-primary">{email}</span>. Check that this exactly matches your
            email address, if it's not correct you can{' '}
            <Link to="/register">register again with the correct address</Link>.
          </li>

          <li>Check your junk mail or 'spam' folder in case the email is there and not in your inbox.</li>

          <li>
            Add <a href="mailto:no-reply@c19testing.co.uk">no-reply@c19testing.co.uk</a> to your 'Safe Senders' list and{' '}
            <Link to="/register">register again</Link>.
          </li>

          <li>
            <strong>Try a different email address</strong>
            <br />
            If your email address was correct and you still can't find the email, it may have been blocked by your email
            provider. Please try registering again with an email address from a different email provider.
          </li>

          <li>
            <strong>Contact support</strong>
            <br />
            If none of the above steps have helped, please <Link to="/contact">contact our support team</Link>.
          </li>
        </ol>
      </div>

      <hr />

      <p className="mt-3">
        <Link to="/register">Register another kit</Link>
      </p>
    </>
  )
}

export default CheckEmailNotice
